import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "message-input-area" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { ref } from "vue";

/**
 * MessageInput is a simple, temporary component for user text input.
 * It will be replaced by the Tiptap-based CanvasEditor later.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageInput',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["sendMessage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const messageText = ref("");

const sendMessage = () => {
  if (props.disabled) return; // Don't send if disabled
  if (messageText.value.trim() !== "") {
    emit("sendMessage", messageText.value);
    messageText.value = ""; // Clear the input after sending
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(sendMessage, ["prevent"]),
      class: "input-form"
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageText).value = $event)),
        type: "text",
        placeholder: "Kirjoita viesti...",
        class: _normalizeClass(["text-input", { disabled: props.disabled }]),
        disabled: props.disabled,
        autofocus: ""
      }, null, 10, _hoisted_2), [
        [_vModelText, messageText.value]
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["send-button", { disabled: props.disabled }]),
        disabled: props.disabled
      }, " Lähetä ", 10, _hoisted_3)
    ], 32)
  ]))
}
}

})